// Adaptive screener concurrency throttle (Phase 5 module) — backs off worker count on Polygon 429s
// and ramps back up after a clean stretch. Depends only on Logger + the ui status node.
import { Logger } from './logger.js';
import { ui } from './ui.js';

export const ScreenerThrottle = {
    START: 10, MIN: 2, MAX: 24,
    target: 8,                 // current allowed concurrent workers
    backoffUntil: 0,           // wall-clock ms until which workers should idle
    backoffStep: 0,           // grows the pause on repeated 429s (exp backoff)
    lastEvent: 0,              // last 429 timestamp
    lastRamp: 0,               // last time we bumped concurrency up
    reset() {
        this.target = this.START; this.backoffUntil = 0;
        this.backoffStep = 0; this.lastEvent = 0; this.lastRamp = Date.now();
        this.updateBadge();
    },
    note429() {
        const now = Date.now();
        // Debounce bursts: many workers can 429 in the same instant — only react once
        // per ~3s so a single spike doesn't collapse the pool to nothing.
        if (now - this.lastEvent < 3000) return;
        this.lastEvent = now;
        this.target = Math.max(this.MIN, Math.floor(this.target / 2)); // halve workers
        this.backoffStep = Math.min(this.backoffStep + 1, 4);
        const pause = 5000 * this.backoffStep;                          // 5s,10s,15s,20s
        this.backoffUntil = now + pause;
        Logger.warn('Screener rate-limited — reducing concurrency', { workers: this.target, backoffMs: pause });
        this.updateBadge(`throttled · ${this.target} workers · backing off ${Math.round(pause/1000)}s`);
    },
    // Called by workers each loop; ramps concurrency back up after a clean stretch.
    maybeRampUp() {
        const now = Date.now();
        if (now < this.backoffUntil) return;
        // 20s+ with no 429 and we're below MAX → add worker slots.
        if (this.target < this.MAX && (now - Math.max(this.lastEvent, this.lastRamp)) > 20000) {
            this.target = Math.min(this.MAX, this.target + 4);
            this.lastRamp = now;
            this.updateBadge();
        }
    },
    inBackoff() { return Date.now() < this.backoffUntil; },
    // Surface the current state in the screener status line, if present.
    updateBadge(msg) {
        try {
            const el = (typeof ui !== 'undefined' && ui.screenerThrottle) ? ui.screenerThrottle : document.getElementById('screenerThrottle');
            if (el) el.textContent = msg || `${this.target} workers`;
        } catch (e) {}
    }
};
